import React from "react";
import makeStyles from "@mui/styles/makeStyles";

import { palette } from "../../theme/palette";

import { View } from "../Base";

const useStyles = makeStyles(() => ({
  label: {
    scale: 0.8,
    marginLeft: "-0.2rem",
    width: "2.5rem",
    height: "1.25rem",
    lineHeight: "1.25rem",
    fontSize: "0.75rem",
    textAlign: "center",
    borderRadius: "0.125rem",
    fontWeight: "bold",
    position: "relative",
  },
  shape: {
    position: "absolute",
    width: "0.25rem",
    height: "0.25rem",
    borderWidth: "0 0.094rem 0.094rem 0",
    borderColor: "white",
    borderStyle: "solid",
    bottom: "0.125rem",
    right: "0.125rem",
  },
}));

const RouteLabel = ({ route }) => {
  const styles = useStyles();
  if (!route) return null;
  else
    return (
      <View
        style={{
          background: route.colour || palette.translucentBlack,
          color: route?.textColour || palette.typography.white.high,
          display: "inline-block",
        }}
        className={styles.label}
      >
        {route.routeCode}
        <View className={styles.shape} />
      </View>
    );
};

export default RouteLabel;
